import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagBR = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M25 9.783 45.652 25 25 40.218 4.348 25 25 9.783Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 33.696a8.696 8.696 0 1 0 0-17.392 8.696 8.696 0 0 0 0 17.392Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M20.652 24.458c-1.512 0-2.971.23-4.345.656a8.694 8.694 0 0 0 15.814 4.875c-2.691-3.369-6.832-5.531-11.469-5.531ZM33.535 26.666a8.696 8.696 0 0 0-16.525-5.098 17.935 17.935 0 0 1 3.642-.372c5.05 0 9.62 2.099 12.883 5.47Z"
}));
FlagBR.displayName = 'FlagBR';
export default withFlagWrapper(FlagBR);
//# sourceMappingURL=index.js.map